import { SECURITY_TOKEN } from './storageKeys';

export class Storage {
    static setSessionValue(key, value) {
        sessionStorage.setItem(key, value);
    }

    static setLocalValue(key, value) {
        localStorage.setItem(key, value);
    }

    static getValue(key) {
        let value = sessionStorage.getItem(key);
        if (value !== null) {
            return value;
        }
        return localStorage.getItem(key);
    }

    static hasSecurityToken() {
        let token = Storage.getSecurityToken();
        return token !== null;
    }

    static setSecurityToken(token) {
        Storage.setLocalValue(SECURITY_TOKEN, token);
    }

    static getSecurityToken() {
        return Storage.getValue(SECURITY_TOKEN);
    }

    static clearSecurityToken() {
        Storage.setLocalValue(SECURITY_TOKEN, null);
    }
}


// WEBPACK FOOTER //
// ./src/Logic/Storage.js